module.exports = __webpack_public_path__ + "img/guess_right_sel.deaa4727.png";